<template>
  <span style="display: inline-block" class="mx-1">
    {{
      $t("Global.address", [
        citiesMap && masterItem ? citiesMap[masterItem.province_id] : "",
        citiesMap && masterItem ? citiesMap[masterItem.city_id] : "",
        citiesMap && masterItem ? citiesMap[masterItem.area_id] : "",
        detailAddress ? detailAddress : "",
      ])
    }}
  </span>
</template>
<script>
import { mapState } from "vuex";
import Cities from "@/api/cities";
export default {
  name: "AddressText",

  props: {
    masterItem: Object,
    detailAddress: String,
  },

  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["citiesMap"]),
  },

  mounted() {
    Cities.fetchMap();//检查并获取全部地址映射
  },
};
</script>